import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { Parallax } from 'react-scroll-parallax'

import { chainDecorators, memoized } from '../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function ParallaxTitle(props) {
  const { className, title, parallax } = props

  return (
    <>
      <div className={classnames('parallax-title', className)}>
        <Parallax translateY={[-40, 50]} speed={-10} {...parallax}>
          <span className="title">{title}</span>
        </Parallax>
      </div>
      <style jsx>{styles}</style>
    </>

  )
}

ParallaxTitle.propTypes = {
  title: PropTypes.string.isRequired,
  parallax: PropTypes.oneOfType(Parallax)
}

ParallaxTitle.defaultProps = {
  title: '',
  parallax: null
}

ParallaxTitle = chainDecorators(decorators, ParallaxTitle)

export default ParallaxTitle
